var map = {
	"./calendar-white.svg": "25ae",
	"./calendar.svg": "d71f",
	"./caret-down-alt.svg": "229c",
	"./caret-down.svg": "5a2a",
	"./caret-left.svg": "27c0",
	"./caret-right-white.svg": "aa4c",
	"./caret-right.svg": "6ab1",
	"./caret-up.svg": "160a",
	"./clipboard.svg": "4fba",
	"./communications.svg": "bab1",
	"./devices.svg": "1a20",
	"./exclamation-mark.svg": "2fcc",
	"./female.svg": "c7a6",
	"./gt.svg": "6006",
	"./heart-handshake.svg": "4b50",
	"./lock.svg": "d3cc",
	"./logo-ascenti-mobile.svg": "762e",
	"./logo-ascenti.svg": "c4f7",
	"./logo-denplan.svg": "8fa6",
	"./logo-patchshealth.svg": "bfd6",
	"./logo-scan.svg": "c761",
	"./logo-simplyhealth-new.svg": "78f5",
	"./lt.svg": "979c",
	"./male.svg": "c9ba",
	"./map-marker-blue.svg": "1e4c",
	"./map-marker-orange.svg": "d4d1",
	"./map-marker-white.svg": "606d",
	"./medical.svg": "2bd0",
	"./phone-white.svg": "979b",
	"./place.svg": "2685",
	"./security.svg": "103a",
	"./tick-white.svg": "2da4",
	"./tick.svg": "f273",
	"./x.svg": "e269"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c6e";